// FASE 4.3 — Inline navbar pill showing the current $REBEL balance.
// Polls /api/shadow/tokens/balance every 60s when the user is authed.
// Click → /shadow/tokens.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Coins } from "lucide-react";
import { API, safeJson } from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";
import { useLanguage } from "../../i18n/LanguageContext";
import { tFases } from "../../i18n/shadow-fases";

export const RebelBalancePill = () => {
  const { user, token } = useAuth();
  const { lang } = useLanguage();
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      if (!user || !token) return;
      try {
        const r = await fetch(`${API}/shadow/tokens/balance`, {
          credentials: "include",
          headers: { Authorization: `Bearer ${token}` },
        });
        const d = await safeJson(r);
        if (mounted && r.ok && d) setBalance(d.balance || 0);
      } catch (_e) { /* non-critical */ }
    };
    load();
    const t = setInterval(load, 60000);
    return () => { mounted = false; clearInterval(t); };
  }, [user, token]);

  if (!user || balance === null) return null;

  const compact = balance >= 10000 ? `${(balance / 1000).toFixed(1)}k` : balance.toLocaleString();

  return (
    <Link
      to="/shadow/tokens"
      data-testid="navbar-rebel-pill"
      title={tFases(lang, "pill_tooltip", { n: balance.toLocaleString() })}
      className="group hidden md:inline-flex items-center gap-1.5 rounded-full border border-amber-400/30 bg-gradient-to-br from-amber-500/[0.08] to-orange-500/[0.04] px-2.5 py-1 font-mono text-[11px] font-black tracking-wider text-amber-200 backdrop-blur transition-all hover:-translate-y-0.5 hover:border-amber-400/60 hover:shadow-[0_4px_18px_rgba(245,158,11,0.35)]"
    >
      <Coins className="h-3 w-3 transition-transform group-hover:rotate-12" />
      {compact}
    </Link>
  );
};

export default RebelBalancePill;
